// Seller profile → dropdown option helpers shared by the Deep Research pickers.

export const labelForProfile = (p) =>
  p?.name || p?.company_name || p?.product_name || "Unnamed profile";

// AutoCompleteDropdown keys options by name, so two profiles both called
// "Salesgear" collide and leave stale rows after a search. Disambiguate
// duplicates with the product name, then a short id as the last resort.
export const uniqueSellerOptions = (profiles = []) => {
  const counts = {};
  profiles.forEach(p => { const l = labelForProfile(p); counts[l] = (counts[l] || 0) + 1; });
  const seen = {};
  return profiles.map(p => {
    let name = labelForProfile(p);
    if (counts[name] > 1) {
      const extra = p.product_name && p.product_name !== name ? p.product_name : "";
      name = extra ? `${name} · ${extra}` : name;
      if (seen[name]) name = `${name} · ${String(p.id).slice(-4)}`;
    }
    seen[name] = true;
    return { id: p.id, name };
  });
};
